"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCommission = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const calculateCommission = (args) => {
    const { lots, orderPrice, contractSize = 1, commissionPercentage } = args;
    const commission = (0, big_1.default)(commissionPercentage).div(100);
    return (0, big_1.default)(lots).times(orderPrice).times(contractSize).times(commission);
};
exports.calculateCommission = calculateCommission;
//# sourceMappingURL=commission.js.map